export default __webpack_public_path__ + "static/media/transfer-limit.f2adb7d3.svg";